module.exports = __webpack_public_path__ + "static/media/multiple_computer.c45fac45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/multiple_computer.svg
// module id = 943
// module chunks = 0